import { apiV1Endpoint } from "../../../../../api/v1";
import { ApiResponse } from "../../../../../types/api-response";
import axios from "../../../../../utils/axiosInceptor";

export type CreateServiceRequest = {
  ticketType: string;
  ticketUserType: string;
  requestFrom: string;
  propertyId: string;
  unitId: string;
  category: Category;
  serviceRequestDetails?: Record<string, unknown>;
};

export type Category = {
  categoryId: string;
  name: string;
};

export const createServiceRequest = async (data: CreateServiceRequest) => {
  const url = `${apiV1Endpoint}/general-services/service-requests`;
  const response = await axios.post<ApiResponse>(url, data);
  return response.data;
};
